  import _ from 'lodash';
  

  /** Returns count of a comma separated list */
  function getUniqueCount(commaSeparatedList){    
    if (commaSeparatedList){
      var splitted = commaSeparatedList.split(",");      
      return _.uniq(splitted).length;
    }
    return 0;
  }

export function parseDatasets(proposals, datasets) { 
   var result = [];
   if (datasets){

     var getProposalById = function(p){ return p.Proposal_proposalId === value.BLSession_proposalId }
     for (let i = 0; i < datasets.length; i++) {
            var value = datasets[i];
            var proposal = _.find(proposals, getProposalById);            
            try{              
              getUniqueCount(value.autoProcIntegrationId)

                result.push({
                    
                    raw: value,                
                    dataCollectionGroupId: value.DataCollectionGroup_dataCollectionGroupId,
                    proposalId : value.BLSession_proposalId,
                    proposal : proposal.Proposal_proposalCode + proposal.Proposal_proposalNumber,
                    startTimeList: value.startTimeList,
                    experimentType: value.DataCollectionGroup_experimentType,
                    directory: value.DataCollection_imageDirectory,
                    
                    workflowType: value.Workflow_workflowType,
                    acronym: value.Protein_acronym,
                    sampleName: value.BLSample_name,
                    prefix: value.DataCollection_imagePrefix,                           
                    runNumber: value.DataCollection_numberOfPasses,
                    numberOfImages: value.DataCollection_numberOfImages,
                    totalNumberOfImages: value.totalNumberOfImages,
                    transmission: value.transmission,

                    resolution: value.DataCollection_resolution,
                    cornerResolution: value.DataCollection_resolutionAtCorner,
                    wavelength: value.DataCollection_wavelength,
                    rotationAxis: value.DataCollection_rotationAxis,
                    axisRange: value.DataCollection_axisRange,
                    axisStart: value.DataCollection_axisStart,
                    axisEnd: value.DataCollection_axisEnd,
                    exposureTime: value.DataCollection_exposureTime,
                    fluxStart: value.DataCollection_flux,
                    fluxEnd: value.DataCollection_flux_end,

                    lastImageId: value.lastImageId,

                    dataCollectionId: value.DataCollection_dataCollectionId,

                    beamlineName: "Not available",
                    detectorDistance: value.DataCollection_detectorDistance,
                    xBeam: value.DataCollection_xBeam,
                    yBeam: value.DataCollection_yBeam,
                    kappaStart: value.DataCollection_kappaStart,
                    phiStart: value.DataCollection_phiStart,

                    synchrotronName: "ESRF",
                    fillingMode: value.BeamLineSetup_synchrotronMode,
                    current: value.synchrotronCurrent,
                    undulatorsTypes: "Not available",
                    undulatorsGaps: "Not available",

                    focusingOptic: value.BeamLineSetup_focusingOptic,
                    MonochromatorType: value.BeamLineSetup_monochromatorType,
                    beamShape: value.DataCollection_beamShape,
                    beamSizeAtSampleX: value.beamSizeAtSampleX,
                    beamSizeAtSampleY: value.beamSizeAtSampleY,
                    beamDivergenceVertical: value.BeamLineSetup_beamDivergenceVertical,
                    beamDivergenceHorizontal: value.BeamLineSetup_beamDivergenceHorizontal,
                    polarisation: value.BeamLineSetup_polarisation,

                    detectorType: value.Detector_detectorType,
                    detectorModel: value.Detector_detectorModel,
                    Manufacturer: value.Detector_detectorManufacturer,
                    detectorPixelSizeHorizontal: value.Detector_detectorPixelSizeHorizontal,
                    detectorPixelSizeVertical: value.Detector_detectorPixelSizeVertical,
                    

                    shippingName: value.Shipping_shippingName,
                    parcelName: value.Dewar_code,
                    containerName: value.Container_code,
                    sampleLocation: value.BLSample_location,
                    beamlineLocation: value.Container_beamlineLocation,
                    sampleChangerLocation: value.Container_sampleChangerLocation,

                    workflowStepTypes: value.WorkflowStep_workflowStepType,
                    workflowStepIds: value.WorkflowStep_workflowStepId,
                    workflowStepStatuses: value.WorkflowStep_status,
                    workflowId: value.Workflow_workflowId,

                    anomalousList : value.Autoprocessing_anomalous,
                    processingProgramIds : value.autoProcIds,
                    processingStatus : value.processingStatus,                    
                    processingPrograms : value.processingPrograms,
                    spaceGroups : value.AutoProc_spaceGroups,
                    scalingStatisticsTypes : value.scalingStatisticsTypes, 
                    rMerges : value.rMerges, 
                    completenessList : value.completenessList,
                    resolutionsLimitHigh : value.resolutionsLimitHigh,
                    resolutionsLimitLow : value.resolutionsLimitLow,
                    cells_a : value.Autoprocessing_cell_a, 
                    cells_b : value.Autoprocessing_cell_b, 
                    cells_c : value.Autoprocessing_cell_c, 
                    cells_alpha : value.Autoprocessing_cell_alpha, 
                    cells_beta : value.Autoprocessing_cell_beta, 
                    cells_gamma : value.Autoprocessing_cell_gamma,


                    ScreeningOutput_indexingSuccess : value.ScreeningOutput_indexingSuccess, 
                    ScreeningOutput_mosaicity : value.ScreeningOutput_mosaicity, 
                    ScreeningOutput_strategySuccess : value.ScreeningOutput_strategySuccess, 
                    summary_datacollection_success : value.summary_datacollection_success, 
                    ScreeningOutputLattice_spaceGroup : value.ScreeningOutputLattice_spaceGroup, 
                    ScreeningOutput_rankingResolution : value.ScreeningOutput_rankingResolution, 
                    ScreeningStrategySubWedge_axisStart : value.ScreeningStrategySubWedge_axisStart, 
                    ScreeningOutput_totalRotationRange : value.ScreeningOutput_totalRotationRange, 
                    ScreeningStrategySubWedge_numberOfImages : value.ScreeningStrategySubWedge_numberOfImages, 
                    ScreeningStrategySubWedge_oscillationRange : value.ScreeningStrategySubWedge_oscillationRange, 
                    ScreeningStrategySubWedge_transmission : value.ScreeningStrategySubWedge_transmission, 
                    ScreeningStrategySubWedge_exposureTime : value.ScreeningStrategySubWedge_exposureTime, 

                    ScreeningOutputLattice_unitCell_a : value.ScreeningOutputLattice_unitCell_a, 
                    ScreeningOutputLattice_unitCell_b : value.ScreeningOutputLattice_unitCell_b, 
                    ScreeningOutputLattice_unitCell_c : value.ScreeningOutputLattice_unitCell_c, 
                    ScreeningOutputLattice_unitCell_alpha : value.ScreeningOutputLattice_unitCell_alpha, 
                    ScreeningOutputLattice_unitCell_beta : value.ScreeningOutputLattice_unitCell_beta, 
                    ScreeningOutputLattice_unitCell_gamma : value.ScreeningOutputLattice_unitCell_gamma, 

                    DataCollectionGroup_comments : value.DataCollectionGroup_comments,

                    totalNumberOfDataCollections : value.totalNumberOfDataCollections,
                    workflowCount : getUniqueCount(value.WorkflowStep_workflowStepId),
                    resultCount : getUniqueCount(value.autoProcIntegrationId),
                    hasPhasing : value.hasPhasing,
                    hasMR : value.hasMR
                    
                    
                    
                });
            }
            catch(e){
                
            }
            
        }
   }
   
   return result;
 }


 


// WEBPACK FOOTER //
// ./src/helpers/Mx/MXDatasetHelper.js